/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEntraMeta200Response
 */
export interface GetEntraMeta200Response {
    /**
     * Azure AD application (client) ID registered for this integration.
     */
    applicationId?: string;
    /**
     * Azure AD tenant ID of the customer's Microsoft 365 directory.
     */
    tenantId?: string;
    /**
     * `active` — integration is configured and working; `inactive` — not yet set up or connection failed.
     */
    status?: GetEntraMeta200ResponseStatusEnum;
}


/**
 * @export
 */
export const GetEntraMeta200ResponseStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
} as const;
export type GetEntraMeta200ResponseStatusEnum = typeof GetEntraMeta200ResponseStatusEnum[keyof typeof GetEntraMeta200ResponseStatusEnum];


/**
 * Check if a given object implements the GetEntraMeta200Response interface.
 */
export function instanceOfGetEntraMeta200Response(value: object): value is GetEntraMeta200Response {
    return true;
}

export function GetEntraMeta200ResponseFromJSON(json: any): GetEntraMeta200Response {
    return GetEntraMeta200ResponseFromJSONTyped(json, false);
}

export function GetEntraMeta200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEntraMeta200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function GetEntraMeta200ResponseToJSON(json: any): GetEntraMeta200Response {
    return GetEntraMeta200ResponseToJSONTyped(json, false);
}

export function GetEntraMeta200ResponseToJSONTyped(value?: GetEntraMeta200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'tenantId': value['tenantId'],
        'status': value['status'],
    };
}

